module.exports = __webpack_public_path__ + "media/images/icon-pushkin-fill-light-637af813088b7ba563de01f80cc71dcf.svg";